export const BG_CORONA_IMAGE_SRC =
  'https://assets.isuzu-tis.com/fallback_3_flare_d780118d77.png';

export const BG_ENGINE_STORY_IMAGE_SRC =
  'https://assets.isuzu-tis.com/fallback_3_bg_desktop_e0406dc98b.jpg';
